import { createBrowserRouter } from "react-router-dom"
import { HomeScreen } from "../screens/HomeScreen"
import { PostsScreen } from "../screens/PostsScreen"
import { UsersScreen } from "../screens/UsersScreen"
import { TransactionsScreen } from "../screens/TransactionsScreen"
import { LogsScreen } from "../screens/LogsScreen"

export const privateRouter = createBrowserRouter([
  {
    path: "/",
    element: <HomeScreen />,
  },
  {
    path: "/posts",
    element: <PostsScreen />,
  },
  {
    path: "/users",
    element: <UsersScreen />,
  },
  {
    path: "/transactions",
    element: <TransactionsScreen />,
  },
  {
    path: "/logs",
    element: <LogsScreen />,
  },
])
